import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { FacetSelectFormComponent } from './components/facet-select-form/facet-select-form.component'
import { UncheckOnDocumentClickModule } from '../uncheck-on-document-click/uncheck-on-document-click.module'
import { AnalyticsModule } from '../analytics/analytics.module'
import { SvgModule } from '../svg/svg.module'

@NgModule({
  imports: [CommonModule, ReactiveFormsModule, SvgModule, UncheckOnDocumentClickModule, AnalyticsModule],
  declarations: [FacetSelectFormComponent],
  exports: [FacetSelectFormComponent],
  providers: []
})
export class FacetsModule {}
